<!-- <ion-header [pageTitle]="pageTitle" (back)="goBack()" class="your-details-header" [helpSupport]="helpSupport"> -->
<ion-header class="ion-header">
  <ion-toolbar class="ion-toolbar">
    <mat-icon class="back-arrow" (click)="goBack()">keyboard_backspace</mat-icon>
    <h1 class="h1">{{ "help-support.Here" | translate }} {{ (user$ | async)?.profile_nickname }}</h1>
    <h2 class="small-title">{{ "help-support.Essential" | translate }}</h2>
  </ion-toolbar>
</ion-header>
@if (helpContent$ | async; as helpContent) {
  <ion-content>
    <div class="item-content-wrapper">
      <!-- <h1 class="define-top">{{ helpContent?.things_to_know?.title }}</h1> -->
      @for (t of helpContent?.getting_started?.details; track t) {
        <ion-item class="item-content">
          <ion-row class="item-row" (click)="getFurtherData(t?.page_url)">
            <ion-col size="10" class="item-left-content">
              <!-- <p *ngIf="t && t.title_new" class="item-left-text">{{t.title_new[selectedLanguage]}}</p>
              <p *ngIf="t && !t.title_new" class="item-left-text">{{t.title}}</p> -->
              <p
                class="item-left-text"
                [innerHTML]="t?._title && t?._title[selectedLanguage] ? t?._title[selectedLanguage] : (t?.title | safeHtml)"
              ></p>
            </ion-col>
            <ion-col size="2" class="item-right-content">
              <ion-icon name="chevron-forward-outline" class="item-right-text"> </ion-icon>
            </ion-col>
          </ion-row>
        </ion-item>
      }
    </div>
    <!--<div class="item-content-wrapper">
    <h1 class="define-top">
      {{
      helpContent?.answers?._title && helpContent?.answers?._title[selectedLanguage]
      ? helpContent?.answers?._title[selectedLanguage]
      : helpContent?.answers?.title
      }}
    </h1>
    <ion-item class="item-content" *ngFor="let t of helpContent?.answers?.details">
      <ion-row class="item-row" (click)="getFurtherData(t?.page_url)">
        <ion-col size="10" class="item-left-content">
          <p class="item-left-text">
            {{ t?._title && t?._title[selectedLanguage] ? t?._title[selectedLanguage] : t?.title }}
          </p>
        </ion-col>
        <ion-col size="2" class="item-right-content">
          <ion-icon name="chevron-forward-outline" class="item-right-text"> </ion-icon>
        </ion-col>
      </ion-row>
    </ion-item>
  </div>-->
  <div style="padding: 0 1vw" class="chatBot_button">
    <ion-card (click)="openChatWindow()" class="chat-wrapper">
      <div>
        <ion-icon class="chat-icon" name="chatbubble"></ion-icon>
      </div>
      <span class="chat-text"> {{ "help-support.Chat" | translate }}</span>
    </ion-card>
  </div>
</ion-content>
}
